import defineBlock from './defineBlock';
import render from './render';
import SmartfireComponent from './SmartfireComponent';
import { smartfireIcon, smartfireYellow } from './icon';
import smartProps from './smartProps';
import * as Internals from './Internals';
import ChildrenBlock from './ChildrenBlock';
import { hooks as editorHooks } from './BlockEditor';
import registerBlock from './registerBlock';

const Smartfire = {
  defineBlock,
  block: defineBlock,
  render,
  registerBlock,
  ChildrenBlock,
  SmartfireComponent,
  smartProps,
  _brand: {
    icon: smartfireIcon,
    colors: {
      yellow: smartfireYellow,
    },
  },
  ...editorHooks,
  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: Internals,
};

export default Smartfire;
